import { Dialog, DialogContent } from "@mui/material";
import AppDialogTitle from "../../../ui/appDialogTitle";
import SearchCustomer from "../../searchCustomer";

export default function SearchCustomerDialog({ open, onClose, onDone }) {

  const handleCustomerSelect = (customer) => {
    onDone(customer);
    onClose();
  };

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth={"xl"}>
      <AppDialogTitle title="Search customer" onClose={onClose} />
      <DialogContent
        sx={{
          minHeight: {
            xs: "400px",
            sm: "800px",
          },
        }}
      >
        <SearchCustomer onDone={handleCustomerSelect} />
      </DialogContent>
    </Dialog>
  );
}
